import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class CmsContactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
